const WOOCOMMERCE = {
  APIAUTH: {
    KEY: "ck_4146c58cfec1af9650f57b4ef0512fa7f9cf1b92",
    SECRET: "cs_c6e6867eecae4b1df5280cbb77235df0ef876649",
  },
}
export default WOOCOMMERCE
